<template lang="html">
    <div id="container">

        <div class="vx-row" v-if="esAfirme">
            <div class="vx-col w-full">
                <div class="afirme-preca">
                    <a class="afirme-back" href="javascript:void(0)" @click="cerrarFormularioAfirme">← Regresar</a>
                    <h2 class="afirme-title">Precalificación Afirme</h2>

                    <ul class="nav afirme-tabs">
                        <li class="nav-item">
                            <button class="nav-link" :class="{ active: afirme.tab === 'personales' }" type="button" @click="afirme.tab = 'personales'">Datos Personales</button>
                        </li>
                        <li class="nav-item">
                            <button class="nav-link" :class="{ active: afirme.tab === 'domicilio' }" type="button" @click="afirme.tab = 'domicilio'">Domicilio</button>
                        </li>
                        <li class="nav-item">
                            <button class="nav-link" :class="{ active: afirme.tab === 'credito' }" type="button" @click="afirme.tab = 'credito'">Crédito</button>
                        </li>
                    </ul>

                    <div class="afirme-card">
                    <div v-show="afirme.tab === 'personales'">
                        <h3 class="afirme-section">Datos de Personales</h3>
                        <div class="row">
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Nombre <span class="text-danger">*</span></label>
                                <input class="afirme-input" v-model="nombre" />
                            </div>
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Segundo Nombre</label>
                                <input class="afirme-input" v-model="afirme.segundoNombre" />
                            </div>
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Apellido Paterno <span class="text-danger">*</span></label>
                                <input class="afirme-input" v-model="apellidoPaterno" />
                            </div>
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Apellido Materno <span class="text-danger">*</span></label>
                                <input class="afirme-input" v-model="apellidoMaterno" />
                            </div>
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">RFC <span class="text-danger">*</span></label>
                                <input class="afirme-input" v-model="rfc" maxlength="13" @input="normalizarRfcAfirme" />
                            </div>
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">CURP <span class="text-danger">*</span></label>
                                <input class="afirme-input" v-model="afirme.curp" maxlength="18" @input="normalizarCurpAfirme" />
                            </div>
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Estado Civil <span class="text-danger">*</span></label>
                                <select class="afirme-input" v-model="afirme.estadoCivil">
                                    <option value="">Seleccione</option>
                                    <option v-for="item in afirmeCatalogos.estadosCiviles" :key="item" :value="item">{{ item }}</option>
                                </select>
                            </div>
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Tipo de Persona <span class="text-danger">*</span></label>
                                <select class="afirme-input" v-model="afirme.tipoPersonaFiscal">
                                    <option value="">Seleccione</option>
                                    <option v-for="item in afirmeCatalogos.tiposPersonaFiscal" :key="item" :value="item">{{ item }}</option>
                                </select>
                            </div>
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Código de País del número Celular <span class="text-danger">*</span></label>
                                <select class="afirme-input" v-model="afirme.codigoPais">
                                    <option v-for="item in afirmeCatalogos.paises" :key="item.codigo" :value="item.codigo">{{ item.nombre }}</option>
                                </select>
                            </div>
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Número de Celular a 10 dígitos <span class="text-danger">*</span></label>
                                <div class="afirme-phone">
                                    <span class="afirme-phone-prefix">{{ afirme.codigoPais || '52' }}</span>
                                    <input class="afirme-input" v-model="afirme.telefono" v-on:keypress="SoloNumero($event)" maxlength="10" />
                                </div>
                            </div>
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Correo Electrónico <span class="text-danger">*</span></label>
                                <input class="afirme-input" v-model="email" />
                            </div>
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Fecha de Nacimiento <span class="text-danger">*</span></label>
                                <input class="afirme-input" type="date" v-model="afirme.fechaNacimiento" placeholder="DD/MM/AAAA" />
                            </div>
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Número de Cliente <span class="text-danger">*</span></label>
                                <input class="afirme-input" v-model="afirme.numeroCliente" />
                            </div>
                        </div>

                        <h3 class="afirme-section">Datos Económicos</h3>
                        <div class="row">
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Años de Antigüedad Laboral <span class="text-danger">*</span></label>
                                <input class="afirme-input" v-model="afirme.aniosLaboral" v-on:keypress="SoloNumero($event)" />
                            </div>
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Meses de Antigüedad Laboral <span class="text-danger">*</span></label>
                                <input class="afirme-input" v-model="afirme.mesesLaboral" v-on:keypress="SoloNumero($event)" />
                            </div>
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Ingreso Mensual <span class="text-danger">*</span></label>
                                <input class="afirme-input" v-model="afirme.ingresoMensual" v-on:keypress="SoloNumero($event)" />
                            </div>
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Otros Ingresos <span class="text-danger">*</span></label>
                                <input class="afirme-input" v-model="afirme.otrosIngresos" v-on:keypress="SoloNumero($event)" />
                            </div>
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Porcentaje de Participación <span class="text-danger">*</span></label>
                                <input class="afirme-input" v-model="afirme.porcentajeParticipacion" v-on:keypress="SoloNumero($event)" />
                            </div>
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Impuestos <span class="text-danger">*</span></label>
                                <input class="afirme-input" v-model="afirme.impuestos" v-on:keypress="SoloNumero($event)" />
                            </div>
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Tipo de Empleo</label>
                                <select class="afirme-input" v-model="afirme.tipoEmpleo">
                                    <option value="">Seleccione</option>
                                    <option v-for="item in afirmeCatalogos.tiposEmpleo" :key="item" :value="item">{{ item }}</option>
                                </select>
                            </div>
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Total de Deudas</label>
                                <input class="afirme-input" v-model="afirme.totalDeudas" v-on:keypress="SoloNumero($event)" />
                            </div>
                        </div>
                    </div>

                    <div v-show="afirme.tab === 'domicilio'">
                        <h3 class="afirme-section">Domicilio</h3>
                        <div class="row">
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Calle <span class="text-danger">*</span></label>
                                <input class="afirme-input" v-model="calle" />
                            </div>
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Número Exterior <span class="text-danger">*</span></label>
                                <input class="afirme-input" v-model="numeroExterior" />
                            </div>
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Número Interior</label>
                                <input class="afirme-input" v-model="numeroInterior" />
                            </div>
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Colonia <span class="text-danger">*</span></label>
                                <input class="afirme-input" v-model="afirme.colonia" />
                            </div>
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Estado <span class="text-danger">*</span></label>
                                <select class="afirme-input" v-model="afirme.estado">
                                    <option value="">Seleccione</option>
                                    <option v-for="item in afirmeCatalogos.estados" :key="item.afirme" :value="item.afirme">{{ item.afirme }}</option>
                                </select>
                            </div>
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Ciudad <span class="text-danger">*</span></label>
                                <input class="afirme-input" v-model="afirme.ciudad" />
                            </div>
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Código Postal <span class="text-danger">*</span></label>
                                <input class="afirme-input" v-model="codigoPostal" maxlength="5" v-on:keypress="SoloNumero($event)" />
                            </div>
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Años de Antigüedad de la Dirección <span class="text-danger">*</span></label>
                                <input class="afirme-input" v-model="afirme.aniosDireccion" v-on:keypress="SoloNumero($event)" />
                            </div>
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Meses de Antigüedad de la Dirección <span class="text-danger">*</span></label>
                                <input class="afirme-input" v-model="afirme.mesesDireccion" v-on:keypress="SoloNumero($event)" />
                            </div>
                        </div>

                        <h3 class="afirme-section">Datos de Garantía</h3>
                        <div class="row">
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Monto Solicitado <span class="text-danger">*</span></label>
                                <input class="afirme-input" v-model="afirme.montoSolicitado" v-on:keypress="SoloNumero($event)" />
                            </div>
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Valor Comercial <span class="text-danger">*</span></label>
                                <input class="afirme-input" v-model="afirme.valorComercial" v-on:keypress="SoloNumero($event)" />
                            </div>
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Destino de Crédito <span class="text-danger">*</span></label>
                                <select class="afirme-input" v-model="afirme.destinoCredito">
                                    <option value="">Seleccione</option>
                                    <option v-for="item in afirmeCatalogos.destinos" :key="item.value" :value="item.value">{{ item.label }}</option>
                                </select>
                            </div>
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Tipo de Garantía <span class="text-danger">*</span></label>
                                <select class="afirme-input" v-model="afirme.tipoGarantia">
                                    <option value="">Seleccione</option>
                                    <option v-for="item in afirmeCatalogos.garantias" :key="item" :value="item">{{ item }}</option>
                                </select>
                            </div>
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Tipo de Propiedad <span class="text-danger">*</span></label>
                                <select class="afirme-input" v-model="afirme.tipoPropiedad">
                                    <option value="">Seleccione</option>
                                    <option v-for="item in afirmeCatalogos.propiedades" :key="item" :value="item">{{ item }}</option>
                                </select>
                            </div>
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Monto Presupuesto de Construcción</label>
                                <input class="afirme-input" v-model="afirme.montoPresupuesto" v-on:keypress="SoloNumero($event)" />
                            </div>
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Pago Mensual Hipoteca</label>
                                <input class="afirme-input" v-model="afirme.pagoMensualHipoteca" v-on:keypress="SoloNumero($event)" />
                            </div>
                        </div>
                    </div>

                    <div v-show="afirme.tab === 'credito'">
                        <h3 class="afirme-section">Crédito</h3>
                        <div class="row">
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Plazo Máximo</label>
                                <input class="afirme-input" v-model="afirme.plazoMaximo" />
                            </div>
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Estado de Dirección de Inmueble <span class="text-danger">*</span></label>
                                <select class="afirme-input" v-model="afirme.estadoInmueble">
                                    <option value="">Seleccione</option>
                                    <option v-for="item in afirmeCatalogos.estados" :key="'inm-' + item.afirme" :value="item.afirme">{{ item.afirme }}</option>
                                </select>
                            </div>
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Tipo de Trámite</label>
                                <select class="afirme-input" v-model="afirme.tipoTramite">
                                    <option value="">Seleccione</option>
                                    <option v-for="item in afirmeCatalogos.tramites" :key="item" :value="item">{{ item }}</option>
                                </select>
                            </div>
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Tipo de Apoyo</label>
                                <select class="afirme-input" v-model="afirme.tipoApoyo">
                                    <option value="">Seleccione</option>
                                    <option v-for="item in afirmeCatalogos.apoyos" :key="item" :value="item">{{ item }}</option>
                                </select>
                            </div>
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Apoyo Infonavit</label>
                                <input class="afirme-input" v-model="afirme.apoyoInfonavit" />
                            </div>
                            <div class="col-md-3 afirme-field">
                                <label class="afirme-label">Deducciones Infonavit</label>
                                <input class="afirme-input" v-model="afirme.deduccionesInfonavit" />
                            </div>
                        </div>
                    </div>

                    <div class="afirme-footer">
                        <button class="afirme-btn-regresar" type="button" :disabled="afirme.tab === 'personales'" @click="regresarAfirmePaso">Regresar</button>
                        <button
                            v-if="afirme.tab !== 'credito'"
                            class="afirme-btn-siguiente"
                            type="button"
                            :disabled="!afirmePuedeAvanzar"
                            @click="siguienteAfirmePaso"
                        >Siguiente</button>
                        <button
                            v-else
                            class="afirme-btn-siguiente"
                            type="button"
                            :disabled="!afirmeCamposCompletos"
                            @click="consultarAfirme"
                        >Consultar</button>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="vx-row" v-else>           
            <div class="vx-col w-full">
                <vx-card title="HSBC" class="mb-base">
                    <div class="row d-flex justify-content-end">
                        <div class="col-6 col-xl-3 text-end">
                            <button class="btn btn-second btn-large" @click="ActiveForm" :disabled="disabledFlag">{{ txtButtonProgreso }} </button>                                    
                        </div>
                        <div class="col-6 col-xl-3">

                          <!------  <vs-button class="btn btn-blue btn-large" @click="validarCredencial" :disabled="activePrecaExterna" >Enviar precalificación 
                            </vs-button>----->

                             <vs-button class="btn btn-blue btn-large" @click="validaCampos" :disabled="activePrecaExterna || !isDisabledForm" >Enviar precalificación 

                            </vs-button>
                          
                            
                           
                        </div>
                        <br><br>
                       
                    </div><br/><br/><br/><br/>
                    
                    <div class="row w-full">
                        <div class="col-md-4">                            
                            <label class="span-placeholder" for="apellidoPaterno">{{apellidoPaternoText}}</label>
                            <input class="v-select vs--single vs--searchable vs-input--input" v-validate="'required|alpha_spaces'" :disabled="isDisabledForm" v-model="apellidoPaterno" name="apellidoPaterno" />
                            <span class="text-danger text-sm" v-show="errors.has('apellidoPaterno')">Campo requerido</span>
                        </div>                               
                        <div class="col-md-4">                            
                            <label class="span-placeholder" for="apellidoMaterno">{{apellidoMaternoText}}</label>
                            <input class="v-select vs--single vs--searchable vs-input--input" v-validate="'required|alpha_spaces'" :disabled="isDisabledForm" v-model="apellidoMaterno" name="apellidoMaterno" />
                            <span class="text-danger text-sm" v-show="errors.has('apellidoMaterno')">Campo requerido</span>
                        </div> 
                        <div class="col-md-4">                            
                            <label class="span-placeholder" for="nombres">{{ nombresText }}</label>
                            <input class="v-select vs--single vs--searchable vs-input--input" v-validate="'required|alpha_spaces'" :disabled="isDisabledForm" v-model="nombre" name="nombres" />
                            <span class="text-danger text-sm" v-show="errors.has('nombres')">Campo requerido</span>
                        </div>
                       
                    </div>   
                    <div class="row w-full">
                        <div class="col-md-2" id="sexoS">  
                            <label class="span-placeholder" for="sexo">Sexo</label>                        
                            <vs-radio :disabled="isDisabledForm" v-model="sexo" vs-name="sexo" name="sexo" vs-value="H">{{sexoH}}</vs-radio>
                            <span class="text-danger text-sm" v-show="errors.has('sexo')">Campo requerido</span>
                        </div>
                        <div class="col-md-2">
                            <label class="" for="sexo">Sexo</label>
                            <vs-radio :disabled="isDisabledForm" v-model="sexo" vs-name="sexo" name="sexo" vs-value="M">{{sexoM}}</vs-radio>
                        </div>
                                                                        
                        <div class="col-md-5  responsive-input ">
                            <span class="span-placeholder" for="fechaNacimiento_dd">Fecha de nacimiento</span>
                            <div class="row w-full responsive-input">
                                <div class="col-md-3">
                                    <input class="vs--single vs--searchable vs-input--input" type="text" :disabled="isDisabledForm" v-model="fechaNacimiento_dd" name="fechaNacimiento_dd" v-validate="'required|max:2'" v-on:keypress="SoloNumero($event)" placeholder="dia"/>
                                    <span class="text-danger text-sm" v-show="errors.has('fechaNacimiento_dd')">max 2 caracteres</span>
                                </div>
                                <div class="col-md-5">
                                    <select name="fechaNacimiento_mm" id="fechaNacimiento_mm" :disabled="isDisabledForm" v-model="fechaNacimiento_mm" v-validate="'required'" class="vs-input--input" placeholder="mes">
                                        <option :value='tipo.id' v-for="tipo in meses">{{tipo.Nombre}}</option>
                                    </select>
                                </div>
                                <div class="col-md-4">
                                    <input class="vs--single vs--searchable vs-input--input" type="text" :disabled="isDisabledForm" v-model="fechaNacimiento_aa" name="fechaNacimiento_aa" v-validate="'required|min:4|max:4'" v-on:keypress="SoloNumero($event)" placeholder="Año" />
                                    <span class="text-danger text-sm" v-show="errors.has('fechaNacimiento_aa')">formato AAAA</span>
                                    
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3  responsive-input ">
                            <span class="span-placeholder" for="nacionalidad">Nacionalidad</span>
                            <select name="nacionalidad" id="nacionalidad" :disabled="isDisabledForm" v-model="nacionalidad" v-validate="'required'" class="v-select vs--single vs--searchable vs-input--input" style="margin-top: 5px;">
                                <option :value='tipo.id' v-for="tipo in nacionalidades"> {{ tipo.Nombre }}</option>                                
                            </select>
                                <span class="text-danger text-sm" v-show="errors.has('nacionalidad')">Campo requerido</span>

                        </div>

                    </div>    
                    <div class="row w-full">
                        <div class="col-md-4 responsive-select">
                            <label class="span-placeholder" for="pais">País</label>
                            <select name="pais" id="pais" :disabled="isDisabledForm" v-model="pais" class="v-select vs--single vs--searchable vs-input--input hgs">
                                <option :value='tipo.Nombre' v-for="tipo in listaPaises" >{{tipo.Nombre}}</option>
                            </select>
                        </div>
                        <div class="col-md-4">                            
                            <label class="span-placeholder" for="rfc">RFC</label>
                            <input class="vs-input" :disabled="isDisabledForm" v-model="rfc" name="rfc" v-validate="'min:13|max:13'" v-mask="'AAAA######NNN'" onkeyup="javascript:this.value=this.value.toUpperCase();" />
                           <!--- <input class="v-select vs--single vs--searchable vs-input--input hgs" :disabled="isDisabledForm" v-model="rfc" name="rfc" v-validate="'min:13|max:13'" v-mask="'AAAA######NNN'" onkeyup="javascript:this.value=this.value.toUpperCase();"/>--->
                            <span class="text-danger span-placeholder" v-show="errors.has('rfc')">El campo debe tener 13 caracteres</span>
                            
                        </div>
                        <div class="col-md-4">
                            <label class="span-placeholder" for="estadoCivil">Estado Civil</label>
                            <select name="estadoCivil" id="estadoCivil" :disabled="isDisabledForm" v-model="estadoCivil" v-validate="'required'" @change="updateRegimenMatrimonial()" class="v-select vs--single vs--searchable vs-input--input hgs">
                                <option :value='tipo.id' v-for="tipo in estadosCiviles" >{{tipo.Nombre}}</option>
                            </select>
                                            <span class="text-danger text-sm" v-show="errors.has('estadoCivil')">Campo requerido</span>
                        </div>

                    </div>    
                    <div class="row w-full">
                        <div class="col-md-4">
                            <label class="span-placeholder" for="regimen">{{ regimenMatromonialText }}</label>
                            <select name="regimen" id="regimen" :disabled="isDisabledForm" v-model="regimenMatrimonial" class="v-select vs--single vs--searchable vs-input--input hgs" disabled>
                                <option :value='tipo.id' v-for="tipo in regimenes" >{{tipo.Nombre}}</option>
                            </select>
                        </div>
                    </div>    

                    <br/><br/><br/>
                    <div class="row w-full">
                        <h4>Empleos e ingresos</h4>  
                        <div class="col-md-4">
                            <label class="span-placeholder" for="domicilioOcupaciones">{{tipoActividadText}}</label>
                            <select name="cars" id="domicilioOcupaciones" :disabled="isDisabledForm" v-model="ingresos.tipoActividad" @change="actualizaMontoIngreso()" class="v-select vs--single vs--searchable vs-input--input hgs" >
                                <option :value='tipo.id' v-for="tipo in ingresos.TipoActividad" >{{tipo.Nombre}}</option>
                            </select>
                        </div> 
                        <div class="col-md-4">                            
                            <label class="span-placeholder" for="ingresoBruto">Ingreso bruto</label>
                            <input class="v-select vs--single vs--searchable vs-input--input hgs"  id="ingresos.ingresoBruto" :disabled="isDisabledForm" v-model="ingresos.ingresoBruto" name="ingresoBruto" v-on:keypress="SoloNumero($event)"  @change="formateaIngresoBruto()" disabled/>
                            
                        </div>  
                        <div class="col-md-4">                            
                            <label class="span-placeholder" for="ingresoNeto">Ingreso neto</label>
                            <input class="v-select vs--single vs--searchable vs-input--input hgs"  id="ingresos.ingresoNeto" :disabled="isDisabledForm" v-model="ingresos.ingresoNeto" name="ingresoNeto" v-on:keypress="SoloNumero($event)"  @change="formateaIngresoNeto()" disabled/>

                        </div>    
                    </div>
                    <div class="row w-full">
                        <div class="col-md-4 responsive-select">                            
                            <label class="span-placeholder" for="formaComprobarIngresos">{{ formaComprobarIngresoText }}</label>
                            <select name="cars" id="formaComprobarIngresos" v-model="ingresos.comprobanteIngresos" class="v-select vs--single vs--searchable vs-input--input hgs" :disabled="isDisabledForm" disabled>                                
                                <option :value="tipo.id" v-for="tipo in ingresos.ComprobanteIngresos" >{{ tipo.Nombre }}</option>
                            </select>
                        </div>
                        <div class="col-md-5">                            
                            <label class="span-placeholder" for="ingresos.antiguedadLaboral">{{antiguedadLaboralText}}</label>
                            <input class="v-select vs--single vs--searchable vs-input--input hgs sizeIputAntiguedadLaboral" v-validate="'required'" :disabled="isDisabledForm" v-model="ingresos.antiguedadLaboral" name="ingresos.antiguedadLaboral" v-on:keypress="SoloNumero($event)"/><br/>
                            <span class="text-danger text-sm" v-show="errors.has('ingresos.antiguedadLaboral')">Campo requerido</span>
                        </div> 
                    </div>
                    <div class="row w-full">
                        <h4>Domicilio Actual</h4> 
                        <div class="col-md-3">                            
                            <label class="span-placeholder" for="cpIngreso">{{ codigoPostalText }}</label>
                            <input class="v-select vs--single vs--searchable vs-input--input hgs" :disabled="isDisabledForm" v-model="codigoPostal" name="cpIngreso" v-validate="'required|min:5|max:5'"
                                v-on:keypress="isNumber($event)" />
                            <span class="text-danger text-sm" v-show="errors.has('cpIngreso')">El campo debe tener 5 caracteres</span>
                        </div>

                        <div class="col-md-3">                            
                            <label class="span-placeholder" for="calle">{{calleText}}</label>
                            <input class="v-select vs--single vs--searchable vs-input--input hgs" v-validate="'required'" :disabled="isDisabledForm" v-model="calle" name="calle" />
                            <span class="text-danger text-sm" v-show="errors.has('calle')">Campo requerido</span>                            
                        </div>                       
                        <div class="col-md-3">                            
                            <label class="span-placeholder" for="numeroExterior">{{numeroExteriorText}}</label>
                            <input class="v-select vs--single vs--searchable vs-input--input hgs" :disabled="isDisabledForm" v-model="numeroExterior" name="numeroExterior" v-validate="'required'" maxlength="5" />
                            <span class="text-danger text-sm" v-show="errors.has('numeroExterior')">Campo requerido</span>
                        </div>

                        <div class="col-md-3">                            
                            <label class="span-placeholder" for="numeroInterior">{{ numeroInteriorText }}</label>                         
                            <input class="v-select vs--single vs--searchable vs-input--input hgs" :disabled="isDisabledForm" v-model="numeroInterior" name="numeroInterior" maxlength="5" />
                        </div>
                    </div>
                    <div class="row w-full">
                        <div class="col-md-4">                            
                            <label class="span-placeholder" for="antiguedadDomicilioActual">{{antiguedadEnDomicilioText}}</label>
                            <input class="v-select vs--single vs--searchable vs-input--input hgs sizeIputAntiguedadLaboral" v-validate="'required'" :disabled="isDisabledForm" v-model="antiguedadDomicilioActual" name="antiguedadDomicilioActual" v-on:keypress="SoloNumero($event)"/><br/>
                            <span class="text-danger text-sm" v-show="errors.has('antiguedadDomicilioActual')">Campo requerido</span>
                        </div>     
                    </div>

                </vx-card>
            </div>
        </div>
        <vs-prompt color="success" title="Precalificación Bancaria"  accept-text="Aceptar"
  cancel-text="Cancel" :active.sync="popupConfirmacion"  @accept="confirmarPrecalificacion"
                            ><b>
                ¿Estas seguro que deseas esta Precalificación al portal de {{ esAfirme ? 'Afirme' : 'HSBC' }}? <br/>
                *Asegurate de que tus credenciales para esta financiera esten correctas
            </b>

        </vs-prompt>

        <vs-prompt color="success" title="Precalificación Bancaria"  accept-text="Aceptar"
  cancel-text="Cancel" :active.sync="popupCamposVacios"  @accept=""><b>
                
                *Asegurate de llenar todo el formulario
            </b>

        </vs-prompt>
        
    </div>
</template>


<script>
import vSelect from 'vue-select'
import { PaisesHSBC } from '@/assets/jsonFiles/PaisesHSBC.js'
import axios from 'axios'
export default { 

    components: {
        'v-select': vSelect,        
    },
    props: {
        varianteId: {
            type: [Number, String],
            required: true
        },
        varianteName: {
            type: String,
            required: true
        },
        bancoId: {
            type: Number,
            default: 6
        },
        tipoPersonaAfirme: {
            type: [Number, String],
            default: 1
        }
    },
    data(){
        return {
            id: '',
            email: '',
            key: '',
            nombre: '',
			apellidoPaterno: '',
			apellidoMaterno: '',            
            sexo: '',
            nacionalidad: '',
            estadoCivil: '',
            estadosCiviles: [
                {id: 1, Nombre: 'Casado'},
                {id: 2, Nombre: 'Divorciado'},
                {id: 3, Nombre: 'Soltero'},
                {id: 4, Nombre: 'Union libre'},
                {id: 5, Nombre: 'Viudo'},
            ],
            regimenMatrimonial: '',            
            regimenes: [                
                {id: 1, Nombre: 'Separados'},
                {id: 2, Nombre: 'Mancomunado'},
            ],
            pais: '',
            isDisabledForm: true,
            txtButtonProgreso: 'Editar',
            rfc: '',
            estadoCivil: '',
            comprobantes: '',
            codigoPostal: '',
            calle: '',
            numeroInterior: '',
            numeroExterior: '',
            antiguedadDomicilioActual: '',
            fechaNacimiento_dd: '',
            fechaNacimiento_mm: '',
            fechaNacimiento_aa: '',
            activePrompt: false,
            activePrecaExterna: false,


            ingresos: {
                ingresoId: '',
                tipoActividad: '',
                ingresoBruto: '',
                ingresoNeto:'',
                comprobanteIngresos : '',
                antiguedadLaboral: '',
                FechaInicio: '',
                TipoActividad: [
                    {id:1, Nombre: 'Asalariado'},
                    {id:42, Nombre: 'Empresario'},
                    {id:14, Nombre: 'Independiente (Honorarios)'}
                ],
                ComprobanteIngresos: [
                    {id: 4, Nombre: 'Declaracion de impuestos'},
                    {id: 18, Nombre: 'Estados de cuenta'},
                ]

            },

            meses: [
                {id: "01", Nombre: "Enero"},
                {id: "02", Nombre: "Febrero"},
                {id: "03", Nombre: "Marzo"},
                {id: "04", Nombre: "Abril"},
                {id: "05", Nombre: "Mayo"},
                {id: "06", Nombre: "Junio"},
                {id: "07", Nombre: "Julio"},
                {id: "08", Nombre: "Agosto"},
                {id: "09", Nombre: "Septiembre"},
                {id: "10", Nombre: "Octubre"},
                {id: "11", Nombre: "Noviembre"},
                {id: "12", Nombre: "Diciembre"},                                
            ],

            nacionalidades: [
                {id: 0, Nombre: ''},
                {id: 1, Nombre: 'Mexicano'},
                {id: 2, Nombre: 'Extranjero'}
            ],

            listaPaises : PaisesHSBC,
            ingresoNuevo : false,
            idIngreso: '',
           
            caso: {
                Plazos: '',
                Programas: '',
                Esquemas: '',
                Destino: '',
                MontoSolicitado: '',
                ValorInmueble: ''


            },            
            
            //titulos de los inputs
            apellidoPaternoText : 'Apellido Paterno',
            apellidoMaternoText : 'Apellido Materno',
            nombresText : 'Nombre(s)',
            sexoH: 'Hombre',
            sexoM: 'Mujer',
            regimenMatromonialText: 'Régimen matrimonial',
            tipoActividadText: 'Tipo de actividad',
            antiguedadLaboralText : 'Antiguedad laboral empleo actual (años)',
            formaComprobarIngresoText: 'Forma de comprobar ingresos',
            codigoPostalText: 'Código postal',
            calleText: 'Calle',
            numeroExteriorText: 'Número exterior',
            numeroInteriorText: 'Número interior',
            antiguedadEnDomicilioText: 'Antiguedad en el domicilio actual (años)',
            popupConfirmacion: false,

            popupCamposVacios:false,

            peticionAPIIntegraSO:'',
            responseAPIIntegraSO:'',
            folioAPI:'',

            emailSolicitanteCaso: '',
            emailCoacreditadoCaso: '',
            estadosSisec: [],
            afirme: {
                tab: 'personales',
                segundoNombre: '',
                curp: '',
                estadoCivil: '',
                tipoPersonaFiscal: '',
                codigoPais: '52',
                telefono: '',
                fechaNacimiento: '',
                numeroCliente: '',
                aniosLaboral: '',
                mesesLaboral: '',
                ingresoMensual: '',
                otrosIngresos: '0',
                porcentajeParticipacion: '',
                impuestos: '',
                tipoEmpleo: '',
                totalDeudas: '',
                colonia: '',
                estado: '',
                ciudad: '',
                aniosDireccion: '',
                mesesDireccion: '',
                montoSolicitado: '',
                valorComercial: '',
                destinoCredito: '',
                tipoGarantia: '',
                tipoPropiedad: '',
                montoPresupuesto: '',
                pagoMensualHipoteca: '',
                plazoMaximo: '',
                estadoInmueble: '',
                tipoTramite: 'TRADICIONAL',
                tipoApoyo: 'SIN APOYO',
                apoyoInfonavit: '',
                deduccionesInfonavit: '',
            },
            afirmeCatalogos: {
                estadosCiviles: [
                    'SOLTERO(A)',
                    'CASADO(A) MANCOMUNADOS',
                    'CASADO(A) BIENES SEPARADOS',
                    'DIVORCIADO(A)',
                    'VIUDO(A)',
                    'UNION LIBRE',
                ],
                tiposPersonaFiscal: ['PF', 'PFAE'],
                paises: [
                    { nombre: 'México', codigo: '52' },
                ],
                tiposEmpleo: [
                    'PROFESIONISTA INDEPENDIENTE',
                    'JUBILADO',
                    'ACCIONISTA INF. EMPRESA',
                    'ACCIONISTA INF. PROPIA',
                    'EMPLEADO DE PLANTA',
                    'ALTO DIRECTIVO DE GOBIERNO',
                ],
                destinos: [
                    { value: 'ADQUISICION', label: 'Adquisición' },
                    { value: 'SUSTITUCION', label: 'Sustitución' },
                ],
                garantias: ['PRINCIPAL', 'ADICIONAL'],
                propiedades: ['CASA HABITACION', 'DEPARTAMENTO', 'TERRENO'],
                tramites: ['TRADICIONAL'],
                apoyos: ['INFONAVIT', 'COFINAVIT', 'SIN APOYO'],
                estados: [
                    { sisec: 'Aguascalientes', afirme: 'AGUASCALIENTES' },
                    { sisec: 'Baja California', afirme: 'BAJA CALIFORNIA NORTE' },
                    { sisec: 'Baja California Sur', afirme: 'BAJA CALIFORNIA SUR' },
                    { sisec: 'Campeche', afirme: 'CAMPECHE' },
                    { sisec: 'Chihuahua', afirme: 'CHIHUAHUA' },
                    { sisec: 'Chiapas', afirme: 'CHIAPAS' },
                    { sisec: 'CDMX', afirme: 'DISTRITO FEDERAL' },
                    { sisec: 'Coahuila', afirme: 'COAHUILA' },
                    { sisec: 'Colima', afirme: 'COLIMA' },
                    { sisec: 'Durango', afirme: 'DURANGO' },
                    { sisec: 'Guanajuato', afirme: 'GUANAJUATO' },
                    { sisec: 'Estado de México', afirme: 'MÉXICO' },
                    { sisec: 'Guerrero', afirme: 'GUERRERO' },
                    { sisec: 'Hidalgo', afirme: 'HIDALGO' },
                    { sisec: 'Morelos', afirme: 'MORELOS' },
                    { sisec: 'Jalisco', afirme: 'JALISCO' },
                    { sisec: 'Michoacán', afirme: 'MICHOACAN' },
                    { sisec: 'Nayarit', afirme: 'NAYARIT' },
                    { sisec: 'Nuevo León', afirme: 'NUEVO LEON' },
                    { sisec: 'Oaxaca', afirme: 'OAXACA' },
                    { sisec: 'Puebla', afirme: 'PUEBLA' },
                    { sisec: 'Quintana Roo', afirme: 'QUINTANA ROO' },
                    { sisec: 'Querétaro', afirme: 'QUERETARO' },
                    { sisec: 'Sinaloa', afirme: 'SINALOA' },
                    { sisec: 'San Luis Potosí', afirme: 'SAN LUIS POTOSI' },
                    { sisec: 'Sonora', afirme: 'SONORA' },
                    { sisec: 'Tabasco', afirme: 'TABASCO' },
                    { sisec: 'Tamaulipas', afirme: 'TAMAULIPAS' },
                    { sisec: 'Tlaxcala', afirme: 'TLAXCALA' },
                    { sisec: 'Veracruz', afirme: 'VERACRUZ' },
                    { sisec: 'Yucatán', afirme: 'YUCATAN' },
                    { sisec: 'Zacatecas', afirme: 'ZACATECAS' },
                ],
            },

        }
    },
    computed: {
        esAfirme() {
            return Number(this.bancoId) === 12
        },
        afirmePersonalesCompletos() {
            if (!this.esAfirme) return false
            const a = this.afirme
            return [
                this.nombre,
                this.apellidoPaterno,
                this.apellidoMaterno,
                this.rfc,
                a.curp,
                a.estadoCivil,
                a.tipoPersonaFiscal,
                a.codigoPais,
                a.telefono,
                this.email,
                a.fechaNacimiento,
                a.numeroCliente,
                a.aniosLaboral,
                a.mesesLaboral,
                a.ingresoMensual,
                a.otrosIngresos,
                a.porcentajeParticipacion,
                a.impuestos,
            ].every((value) => value !== null && value !== undefined && String(value).trim() !== '')
        },
        afirmeDomicilioCompletos() {
            if (!this.esAfirme) return false
            const a = this.afirme
            return [
                this.calle,
                this.numeroExterior,
                a.colonia,
                a.estado,
                a.ciudad,
                this.codigoPostal,
                a.aniosDireccion,
                a.mesesDireccion,
                a.montoSolicitado,
                a.valorComercial,
                a.destinoCredito,
                a.tipoGarantia,
                a.tipoPropiedad,
            ].every((value) => value !== null && value !== undefined && String(value).trim() !== '')
        },
        afirmeCreditoCompletos() {
            if (!this.esAfirme) return false
            return this.afirme.estadoInmueble !== null && this.afirme.estadoInmueble !== undefined && String(this.afirme.estadoInmueble).trim() !== ''
        },
        afirmeCamposCompletos() {
            return this.afirmePersonalesCompletos && this.afirmeDomicilioCompletos && this.afirmeCreditoCompletos
        },
        afirmePuedeAvanzar() {
            if (this.afirme.tab === 'personales') return this.afirmePersonalesCompletos
            if (this.afirme.tab === 'domicilio') return this.afirmeDomicilioCompletos
            return this.afirmeCamposCompletos
        },
    },
    watch: {
        tipoPersonaAfirme() {
            if (this.esAfirme) {
                this.aplicarEmailPersonaAfirme()
                this.dameSolicitante()
            }
        },
    },
    created() {
        this.updateText();
        window.addEventListener('resize', this.updateText);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateText);
    },
    mounted() {
        this.id = this.$route.params.id
		this.key = JSON.parse(localStorage.getItem('userInfo')).ApiKey
                
        this.normalizeArray()
        if (this.esAfirme) {
            this.getEstadosSisec()
        }
        this.dameCaso()  

        
    },
    methods: {

         normalizeString(str) {
         return str.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
        },
        normalizeArray(){
            for (let index = 0; index < this.listaPaises.length; index++) {
                
                this.listaPaises[index].Nombre = this.normalizeString(this.listaPaises[index].Nombre);               
                //console.log("normalizae ? " + this.listaPaises[index].Nombre)    
            }                        
                       
            

        },
        updateText() {
           
            if (window.innerWidth <= 1200) { //768
                this.apellidoPaternoText = 'Apellido P';
                this.apellidoMaternoText = 'Apellido M';
                this.sexoH = 'H';
                this.sexoM = 'M';
                this.regimenMatromonialText =  'Reg. matrimonial';
                this.tipoActividadText = 'Actividad';
                this.antiguedadLaboralText = 'Antiguedad Laboral';
                this.formaComprobarIngresoText = 'Compr. Ingresos';
                this.codigoPostalText =  'C.P.',
                this.calleText =  'Calle',
                this.numeroExteriorText =  'Número ext.',
                this.numeroInteriorText =  'Número int.',
                this.antiguedadEnDomicilioText = 'Antiguedad';                
            }else{
                this.apellidoPaternoText = 'Apellido Paterno';
                this.apellidoMaternoText = 'Apellido Materno';
                this.sexoH = 'Hombre';
                this.sexoM = 'Mujer';
                this.regimenMatromonialText =  'Régimen matrimonial',
                this.tipoActividadText = 'Tipo de actividad';
                this.antiguedadLaboralText = 'Antiguedad laboral empleo actual (años)';
                this.formaComprobarIngresoText = 'Forma de comprobar ingresos';
                this.codigoPostalText =  'Código postal';
                this.calleText =  'Calle';
                this.numeroExteriorText =  'Número exterior';
                this.numeroInteriorText =  'Número interior';
                this.antiguedadEnDomicilioText =  'Antiguedad en el domicilio actual (años)';      
                                
            }
        },
        ActiveForm() {
			if (this.esAfirme) return
			!this.isDisabledForm && this.actualizarInfo(false)

			this.isDisabledForm = !this.isDisabledForm
			this.txtButtonProgreso = !this.isDisabledForm ? 'Guardar Progreso' : 'Editar'
            

            if (this.estadoCivil == 1) {
                document.getElementById('regimen').disabled = false
            }

            if (this.ingresos.tipoActividad == 42) {
                document.getElementById('ingresos.ingresoBruto').disabled = false 
                document.getElementById('formaComprobarIngresos').disabled = false   
            }else if(this.ingresos.tipoActividad == 14){
                document.getElementById('ingresos.ingresoNeto').disabled = false
                document.getElementById('formaComprobarIngresos').disabled = false   
            } else if(this.ingresos.tipoActividad == 1){
                document.getElementById('ingresos.ingresoNeto').disabled = false
            }                       
		},        
        SoloNumero: function(evt){
			evt = evt ? evt : window.event
			var charCode = evt.which ? evt.which : evt.keyCode
			if (charCode > 31 && (charCode < 48 || charCode > 57)) {
				evt.preventDefault()
			} else {
				return true
			}
		},
        dameCaso() {
			let self = this
			var objRequestDameCaso = {
				strApiKey: this.key,
				strMetodo: 'DameCaso',
				objCaso: {
					Id: this.id,
				},
			}
			this.$axios
				.post('/', objRequestDameCaso, { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } })
				.then((response) => {
					if (response.data.intEstatus == 0) {
                        let data = response.data.objContenido						
                        this.email = data.Solicitante
                        this.emailSolicitanteCaso = data.Solicitante
                        this.emailCoacreditadoCaso = (data.Coacreditado && data.Coacreditado[0] && data.Coacreditado[0].EMail) ? data.Coacreditado[0].EMail : ''

                        this.caso.Plazos = data.Plazos,
						this.caso.Programas = data.Programas,
						this.caso.Esquemas = data.Esquemas,
                        this.caso.Destino = data.Destino,
                        this.caso.ValorInmueble = data.ValorInmueble,
                        this.caso.MontoSolicitado = data.MontoSolicitado

                        if (this.esAfirme) {
                            this.llenarAfirmeDesdeCaso(data)
                            this.aplicarEmailPersonaAfirme()
                        }
                        
                        console.log(this.caso);

						this.dameSolicitante()
						
					} else {
						this.$vs.notify({
							title: 'Ocurrio un error en DameCaso',
							text: response.data.strError,
							color: 'danger',
							position: 'top-right',
						})
					}
				})
				.catch(function (error) {
					self.$vs.notify({
						title: 'Ocurrio un error de sistema',
						text: error,
						color: 'danger',
						position: 'top-right',
					})
				})
		},
        dameSolicitante() {
			let self = this
			var objRequestDameSolicitante = {
				strFolioCaso: this.id,
				strApiKey: this.key,
				strMetodo: 'DameSolicitante',
				objSolicitante: {
					EMail: this.email,
				},
			}
            console.log()
			this.$axios
				.post('/', objRequestDameSolicitante, { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } })
				.then((response) => {
					if (response.data.intEstatus == 0) {
						let solicitante = response.data.objContenido
                        let solicitanteIngresos = solicitante.Ingresos


                        this.nombre = this.esAfirme ? (solicitante.Nombres || '') : (solicitante.Nombres + ' ' + solicitante.SegundoNombre)
                        this.apellidoMaterno = solicitante.ApellidoMaterno
                        this.apellidoPaterno = solicitante.ApellidoPaterno

                        if (solicitante.Sexo == 1) {
                            this.sexo = 'H'    
                        }else if(solicitante.Sexo == 2){
                            this.sexo = 'M'
                        }
                        var fechaNac = String(solicitante.FechaNacimiento || '').split('-');
                        this.fechaNacimiento_dd = fechaNac[2] || ''
                        this.fechaNacimiento_mm = fechaNac[1] || ''
                        this.fechaNacimiento_aa = fechaNac[0] || ''

                       if(solicitante.Nacionalidad != null){                                
                            if (solicitante.Nacionalidad == 'MEXICANO (A)') {
                                this.nacionalidad = 1
                            }else{
                                this.nacionalidad = 2
                            }
                        }else
                            this.nacionalidad = ''
                            
                        this.rfc = solicitante.Rfc
                        this.estadoCivil = solicitante.EstadoCivil
                        this.regimenMatrimonial = solicitante.RegimenMatrimonial

                        //INGRESOS
                        
                        if (solicitanteIngresos.length > 0 ) {
                                                        
                            this.ingresos.ingresoId = solicitanteIngresos[0].Id
                            if (solicitanteIngresos[0].TipoEmpleoId == 1) {
                                this.ingresos.tipoActividad = 1                                                                                           
                            }else if(solicitanteIngresos[0].TipoEmpleoId == 42){
                                this.ingresos.tipoActividad = 42
                                //this.ingresos.ingresoBruto = solicitanteIngresos[0].IngresosMensuales
                               
                            }else if(solicitanteIngresos[0].TipoEmpleoId == 14 || solicitanteIngresos[0].TipoEmpleoId == 44){
                                this.ingresos.tipoActividad = 14
                                //this.ingresos.ingresoNeto = solicitanteIngresos[0].IngresosNetos
                                                  
                            }else{
                                this.ingresos.tipoActividad = null
                            }

                            this.ingresos.ingresoNeto = solicitanteIngresos[0].IngresosNetos
                            this.ingresos.ingresoBruto = solicitanteIngresos[0].IngresosMensuales

                            if (solicitanteIngresos[0].ComprobanteIngresosId == 4)
                                this.ingresos.comprobanteIngresos = 4
                            if (solicitanteIngresos[0].ComprobanteIngresosId == 18)
                                this.ingresos.comprobanteIngresos = 18

                            /*if (solicitanteIngresos[0].ComprobanteIngresosId == 4 && (solicitanteIngresos[0].TipoEmpleoId == 42 || solicitanteIngresos[0].TipoEmpleoId == 14 || solicitanteIngresos[0].TipoEmpleoId == 44)) {
                                this.ingresos.comprobanteIngresos = 4
                            }else if (solicitanteIngresos[0].ComprobanteIngresosId == 18 && (solicitanteIngresos[0].TipoEmpleoId == 42 || solicitanteIngresos[0].TipoEmpleoId == 14 || solicitanteIngresos[0].TipoEmpleoId == 44)) {
                                this.ingresos.comprobanteIngresos = 18
                            }*/
                        
                            var fechaActual = this.dameFechaActual()                            
                            var fechaInicio = new Date(solicitanteIngresos[0].FechaInicio).getTime();                                                    
                            var fechaFin    = new Date(fechaActual).getTime();
                            var diff = fechaFin - fechaInicio;
                            var dias = diff/(1000*60*60*24)
                            var anios = dias / 355
                            

                            this.ingresos.antiguedadLaboral = Math.round(anios)
                            

                            this.formateaIngresoBruto()
                            this.formateaIngresoNeto()

                        }else{
                            this.ingresoNuevo = true
                        }


                        // DOMICILIO ACTUAL
                        this.codigoPostal = solicitante.CodigoPostal
                        this.calle = solicitante.Calle
                        this.numeroExterior = solicitante.NumeroExterior
                        this.numeroInterior = solicitante.NumeroInterior
                        this.antiguedadDomicilioActual = solicitante.TiempoViviendoCiudad


                        //this.pais = solicitante.PaisExtranjero
                        if(solicitante.PaisRecidencia)
                            this.pais = this.normalizeString(solicitante.PaisRecidencia.toUpperCase())
                        //console.log("PASIS " + this.)

                        if (solicitante.PaisRecidencia == 'COSTA DE MARFIL' || solicitante.PaisRecidencia == 'ESLOVENIA' || solicitante.PaisRecidencia == 'ESPAÑA' || solicitante.PaisRecidencia == 'ISLAS SALOMÓN'
                            || solicitante.PaisRecidencia == 'SRI LANKA' || solicitante.PaisRecidencia == 'SUDÁN DEL SUR'
                        ) {
                            this.pais = ''
                        }
                        else{                          
                            this.listaPaises.forEach(element => {                                
                                if(this.pais == element.Nombre)
                                    this.pais = element.Nombre                         
                            });
                        }

                        if (this.esAfirme) {
                            this.llenarAfirmeDesdeSolicitante(solicitante, solicitanteIngresos)
                        }

                    } else {
						this.$vs.notify({
							title: 'Ocurrio un error en DameSolicitante dameSolicitante',
							text: response.data.strError,
							color: 'danger',
							position: 'top-right',
						})
					}
				})
				.catch(function (error) {
					self.$vs.notify({
						title: 'Ocurrio un error de sistema',
						text: error,
						color: 'danger',
						position: 'top-right',
					})
				})
		},
        async actualizarInfo(){
            
            if (this.ingresos.ingresoBruto != '') {
                this.ingresos.ingresoBruto = parseFloat(this.ingresos.ingresoBruto.replace(/,/g, ''))
            }

            if (this.ingresos.ingresoNeto != '') {
                this.ingresos.ingresoNeto = parseFloat(this.ingresos.ingresoNeto.replace(/,/g, ''))
            }



            var Sexo
            var Nacionalidad
            var IdNacionalidad

            this.sexo == 'H' ? Sexo = 1 : Sexo = 2
            this.nacionalidad == 1 ? Nacionalidad = 'MEXICANO (A)' : Nacionalidad = 'NORTEAMERICANO (A)'
            this.nacionalidad == 1 ? IdNacionalidad = '1' : IdNacionalidad = '2'

            let self = this
			var objRequestActualizaInfo = {
				strFolioCaso: this.id,
				strApiKey: this.key,
				strMetodo: 'RegistraSolicitante',
				objSolicitante: {
                    EMail: this.email,
					ApellidoMaterno: this.apellidoMaterno,
                    ApellidoPaterno: this.apellidoPaterno,
                    Nombres: this.nombre,
                    SegundoNombre: '',
                    Sexo: Sexo,
                    FechaNacimiento : this.fechaNacimiento_aa + "-" + this.fechaNacimiento_mm + "-" + this.fechaNacimiento_dd,                  
                    Nacionalidad: {
						id: IdNacionalidad,
						name: Nacionalidad,
                        updateScotia:true
					},
                    PaisRecidencia: this.pais,
                    Rfc: this.rfc,
                    EstadoCivil: this.estadoCivil,
                    RegimenMatrimonial: this.regimenMatrimonial,
                    CodigoPostal: this.codigoPostal,
                    Calle: this.calle,
                    NumeroExterior: this.numeroExterior,
                    NumeroInterior: this.numeroInterior,
                    TiempoViviendoCiudad: this.antiguedadDomicilioActual
				},
			}


            
			///const validator = await this.$validator.validateAll()            			

			/*if ( !validator ) {

				this.$vs.notify({
					title: 'Ocurrio un error',
					text: 'Datos incompletos',
					color: 'danger',
					position: 'top-right',
				})
                this.formateaIngresoBruto()
                this.formateaIngresoNeto()

				return false

			}*/

            const response = await this.$axios.post('/', objRequestActualizaInfo, { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } })

			const { intEstatus, objContenido } = response

            if ( intEstatus ) {

                this.$vs.notify({
                    title: 'Ocurrio un error en RegistraSolicitante',
                    text: response.data.strError,
                    color: 'danger',
                    position: 'top-right',
                })

                return false

            }
            this.$vs.loading({
				container: '#container',
				scale: 0.6,
			})

            if (this.ingresos.antiguedadLaboral > 0) {
                var arrayFecha = (this.dameFechaActual()).split('-')
                var anioInicio = parseFloat(arrayFecha[0]) - parseFloat(this.ingresos.antiguedadLaboral)
                console.log(arrayFecha)
                console.log(anioInicio)
                this.ingresos.FechaInicio = anioInicio + "-"+arrayFecha[1]+"-"+arrayFecha[2]
                console.log(this.ingresos.FechaInicio)
            }                        
            this.ingresoNuevo ? this.registraIngreso() : this.editarIngreso()  

            this.formateaIngresoBruto()
            this.formateaIngresoNeto()
            
            document.getElementById('regimen').disabled = true   
            document.getElementById('ingresos.ingresoBruto').disabled = true
            document.getElementById('ingresos.ingresoNeto').disabled = true
            document.getElementById('formaComprobarIngresos').disabled = true
        },      
        registraIngreso(){                                      
            let self = this
			var objRequestListaCasos = {
				strFolioCaso: this.id,
				strApiKey: this.key,
				strMetodo: 'RegistraIngresos',
				objSolicitante: {
					EMail: this.email,
					Ingresos: [
						{
							IngresosMensuales: this.ingresos.ingresoBruto,
							IngresosNetos: this.ingresos.ingresoNeto,
							TipoEmpleo: this.ingresos.tipoActividad,							
					        FechaInicio: this.ingresos.FechaInicio,							
							ComprobanteIngresos: this.ingresos.comprobanteIngresos,							
						},
					]					
				},
			}
			this.$axios
				.post('/', objRequestListaCasos, { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } })
				.then((response) => {
					if (response.data.intEstatus == 0) {
						this.$vs.notify({
							title: `Datos guardados exitosamente`,
							position: 'top-right',
						})						
					} else {
						this.$vs.notify({
							title: 'Ocurrio un error en RegistraIngresos',
							text: response.data.strError,
							color: 'danger',
							position: 'top-right',
						})
					}
					this.$vs.loading.close('#container > .con-vs-loading')
				})
				.catch(function (error) {
					self.$vs.notify({
						title: 'Ocurrio un error de sistema',
						text: error,
						color: 'danger',
						position: 'top-right',
					})
				})

        },
        editarIngreso(){
                      
            var objRequestRegistraCuentasBancarias = {
				strFolioCaso: this.id,
				strApiKey: this.key,
				strMetodo: 'EditarIngresos',
				objSolicitante: {
					EMail: this.email,
					Ingresos: [
						{
                            Id: this.ingresos.ingresoId,
							IngresosMensuales:this.ingresos.ingresoBruto,
							IngresosNetos:this.ingresos.ingresoNeto,
							TipoEmpleo: this.ingresos.tipoActividad,
                            ComprobanteIngresos: this.ingresos.comprobanteIngresos,
                            FechaInicio: this.ingresos.FechaInicio,							
						},
					],					
				},
			}
			this.$axios
				.post('/', objRequestRegistraCuentasBancarias, { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } })
				.then((response) => {
					if (response.data.intEstatus == 0) {
						this.$vs.notify({
							title: `Datos guardados exitosamente`,
							position: 'top-right',
						})	
                        this.$vs.loading.close('#container > .con-vs-loading')					
					} else {
						this.$vs.notify({
							title: 'Ocurrio un error en EditarIngresos',
							text: response.data.strError,
							color: 'danger',
							position: 'top-right',
						})
					}
				})
				.catch(function (error) {
					self.$vs.notify({
						title: 'Ocurrio un error de sistema',
						text: error,
						color: 'danger',
						position: 'top-right',
					})
				})

        },
        validaCampos(){

           console.log('sexo'+this.sexo)
            console.log('nacionalidad'+this.nacionalidad)
            console.log('pais'+this.pais)
            console.log('rfc'+this.rfc)
            console.log('estado civil'+this.estadoCivil)
            console.log('r matri'+this.regimenMatrimonial)
            console.log('cp'+this.codigoPostal)
            console.log('calle'+this.calle)
            console.log('#ext'+this.numeroExterior)
            console.log('#int'+this.numeroInterior)
            console.log('antigueDomi'+this.antiguedadDomicilioActual)

            console.log('ingresoBruto'+this.ingresos.ingresoBruto)
            console.log('ingresoNeto'+this.ingresos.ingresoNeto)
            console.log('tipoActividad'+this.ingresos.tipoActividad)
            console.log('FechaInicio'+this.ingresos.antiguedadLaboral)
            console.log('comprobanteIngresos'+this.ingresos.comprobanteIngresos)

            ///if(this.sexo=='' || this.nacionalidad=='' || this.pais=='' ||  (this.rfc=='null' || this.rfc=='' ) || this.estadoCivil=='null' || this.codigoPostal=='null' || this.calle == 'null' || this.numeroExterior=='null'  || this.antiguedadDomicilioActual=='null' || this.ingresos.tipoActividad=='' || this.ingresos.antiguedadLaboral==''){
            if((this.sexo=='' || this.sexo=='null') || (this.nacionalidad=='' || this.nacionalidad=='null') || (this.pais=='' || this.pais=='null') ||  (this.rfc=='null' || this.rfc=='' ) || (this.estadoCivil=='' || this.estadoCivil=='null') || (this.codigoPostal=='null' || this.codigoPostal=='') || (this.calle == 'null' || this.calle == '') || (this.numeroExterior=='null' || this.numeroExterior=='')  || (this.antiguedadDomicilioActual=='null' || this.antiguedadDomicilioActual=='' ) || (this.ingresos.tipoActividad=='' || this.ingresos.tipoActividad=='null') || (this.ingresos.antiguedadLaboral=='' || this.ingresos.antiguedadLaboral=='null')){
                
               //// console.log('if campos vacios')


               this.popupCamposVacios = true; // Mostrar popup
                
                

            } else{

               /// console.log('else campos')
                if(this.ingresos.tipoActividad==1){
                    if(this.ingresos.ingresoNeto=='' || this.ingresos.ingresoNeto=='0.00'){
                        this.$vs.notify({
							title: 'Información',
							text: 'Favor de Registrar un Ingreso Neto valido',
							color: 'warning',
							position: 'top-right',
						})
                    }else{
                        this.validarCredencial()
                    }
                }else if(this.ingresos.tipoActividad==42){
                    if((this.ingresos.ingresoBruto==''|| this.ingresos.ingresoBruto=='0.00') || this.ingresos.comprobanteIngresos=='' ){
                       /// console.log('campo vacio ingresoBruto y comprobanteIngresos')

                       this.$vs.notify({
							title: 'Información',
							text: 'Favor de Registrar un Ingreso Bruto y Comprobante de Ingresos',
							color: 'warning',
							position: 'top-right',
						})
                    }else{
                        this.validarCredencial()
                    }
                }else if(this.ingresos.tipoActividad==14){
                    if((this.ingresos.ingresoNeto=='' || this.ingresos.ingresoNeto=='0.00') || this.ingresos.comprobanteIngresos=='' ){
                        this.$vs.notify({
							title: 'Información',
							text: 'Favor de Registrar un Ingreso Neto y Comprobante de Ingresos',
							color: 'warning',
							position: 'top-right',
						})
                    }else{
                        this.validarCredencial()
                    }
                }

               

            }

        },
        

        async validarCredencial(){
            var objRequestRegistraCuentasBancarias = {
				strApiKey: this.key,
				strMetodo: 'ValidarBancoHSBC',
				objCaso: {					
                	Banco: 6 //hsbc 6: santander 10: Scotiabank 11		
                },
			}
            await this.$axios
				.post('/', objRequestRegistraCuentasBancarias, { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } })
				    .then((response) => {
                        console.log(response.data);
                         if (response.data.intEstatus == 0) {
                            this.popupConfirmacion = true; // Mostrar popup
                            //this.precalificacionLinea();
                         }
                         else
                         {
                           this.$vs.notify({
							title: 'Información',
							text: response.data.strError,
							color: 'warning',
							position: 'top-right',
						})
                         
                         }
                        })
                        .catch(function (error) {
                            this.$vs.notify({
                                title: 'Ocurrio un error de sistema',
                                text: error,
                                color: 'danger',
                                position: 'top-right',
                            });
                        
                        })
                    
        },

        async validarPeticionHSBCUnicaMes(){
            let respuesta=false;
            var ObjParam = {
				strApiKey: this.key,
				strMetodo: 'validateExisteRegistroHSBC',
				objCaso: {					
                	EMail: this.email //hsbc 6: santander 10: Scotiabank 11		
                },
			}
            await this.$axios
				.post('/', ObjParam, { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } })
				    .then((response) => {
                        console.log(response.data);
                         if (response.data.intEstatus == 0) {
                            //this.precalificacionLinea();
                            respuesta=true;
                         }
                         else
                         {
                           this.$vs.notify({
							title: 'Información',
							text: 'Ya existe un registro en HSBC para el solicitante',
							color: 'warning',
							position: 'top-right',
						})
                         
                         }
                        })
                        .catch(function (error) {
                            this.$vs.notify({
                                title: 'Ocurrio un error de sistema',
                                text: error,
                                color: 'danger',
                                position: 'top-right',
                            });        
                    })
                    
            return respuesta;
        },
       

        async guardarCotizacionHSBC()
        {
           
                var datos = {
                    strApiKey: this.key,
                    strMetodo: 'GuardarBancoHSBC',
                    objCaso: {					
                        Id: this.id,
                        Banco: 6, //hsbc 6: santander 10: Scotiabank 11		
                        EMail: this.email,	      
                        folio:this.folioAPI,
                        peticion:this.peticionAPIIntegraSO,
                        response:this.responseAPIIntegraSO,
                        DatosCredito: {
                            Plazo: this.caso.Plazos[0],
                            Programa: this.caso.Programas[0],
                            Esquema: this.caso.Esquemas[0],
                            Destino: this.caso.Destino,		
                            MontoSolicitado: this.caso.MontoSolicitado,
                            ValorPropiedad: this.caso.ValorInmueble,				
                            Variante: this.varianteId
                        },	            
                    },
                }
                await this.$axios
                    .post('/', datos, { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } })
                    .then((response) => {
                        console.log(response.data);
                        this.$vs.dialog({
                        color:'primary',
                        title: 'Aviso',
                        text: 'Recuerda terminar de llenar los \n formularios directo desde el portal \n de HSBC',
                        acceptText: 'Aceptar',                        
                        });
                        this.$emit('bandera', 'Personales')

                    })
                    .catch(function (error) {
                        this.$vs.notify({
                            title: 'Ocurrio un error de sistema',
                            text: error,
                            color: 'danger',
                            position: 'top-right',
                        })
                    })
        },

        async precalificacionLinea() {
          
            
                this.$vs.loading({
                    container: '#container',
                    scale: 0.6,
                });         
            try 
            {
                let peticionUnica=await this.validarPeticionHSBCUnicaMes();
                if(peticionUnica)
                {
                    var objRequestRegistraCuentasBancarias = {
                        strFolioCaso: this.id,
                        strApiKey: this.key,
                        strMetodo: 'SolicitarEnLineaHsbcV2',
                        objCaso: {					
                            Id: this.id,
                            EMail: this.email,
                            Banco: 6, //hsbc 6: santander 10: Scotiabank 11		
                            DatosCredito: {
                                Plazo: this.caso.Plazos[0],
                                Programa: this.caso.Programas[0],
                                Esquema: this.caso.Esquemas[0],
                                Destino: this.caso.Destino,		
                                MontoSolicitado: this.caso.MontoSolicitado,
                                ValorPropiedad: this.caso.ValorInmueble,				
                                Variante: this.varianteId
                            },	                    
                        },
                    }
                    const response1= await this.$axios.post('/', objRequestRegistraCuentasBancarias, { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } });
                    
                    if (response1.data.intEstatus === 0) 
                    {
                        console.log(response1.data.objContenido);
                        const ObjParam = {
                            metodo: "crearcaso",
                            datos: response1.data.objContenido
                        };

                        //this.$axios.post('https://preprodcotizador.socasesores.com/Multilogin/CierraMultilogin.php',objGeneraCodigo,{headers : {'Content-Type':'application/json; charset=UTF-8'}})
      
                        const response2 = await axios.post('https://preprodcotizador.socasesores.com/api_integra/api.php',
                        

                            ObjParam,
                            {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                            }
                        );
                        console.log(response2.data)
                        if(response2.data.message!==undefined)
                        {
                            if(response2.data.message=="Created"){
                                let response=response2.data;
                                this.folioAPI=response2.data.data.id;
                                this.responseAPIIntegraSO={response};
                                this.peticionAPIIntegraSO={ObjParam};
                                await this.guardarCotizacionHSBC();
                            }
                            else
                            {
                                this.$vs.dialog({
                                    color:'danger',
                                    title: 'Ocurrio error en registrar solicitud',
                                    text: 'Ocurrio un error intente mas tarde',
                                    acceptText: 'Aceptar',                        
                                });
                            }
                            
                        }
                        else
                        {

                               /* let response=response2.data;
                                this.folioAPI='1223';
                                this.responseAPIIntegraSO={response};
                                this.peticionAPIIntegraSO={ObjParam};
                                await this.guardarCotizacionHSBC();*/
                            
                            this.$vs.dialog({

                                color:'danger',
                                title: 'Ocurrio error en registor de solicitud Bancaria',
                                text: 'Ocurrio un error intente mas tarde',
                                acceptText: 'Aceptar',                        

                            });

                        }

                    }
                    else
                    {
                        this.$vs.notify({
                            title: 'Ocurrio un error de sistema',
                            text: 'No esta registrado el Banco con el Broker',
                            color: 'danger',
                            position: 'top-right',
                        })
                    }
                }
            }
            catch(error) 
            {
                self.$vs.notify({
                    title: 'Ocurrio un error de sistema',
                    text: error,
                    color: 'danger',
                    position: 'top-right',
                })            
            }
            this.$vs.loading.close('#container > .con-vs-loading')
                

            //
        },
        updateRegimenMatrimonial(){
            if ( this.estadoCivil == 1) {
                document.getElementById("regimen").disabled = false                
                this.regimenMatrimonial = 1
            }else{
                document.getElementById("regimen").disabled = true
                this.regimenMatrimonial = ''
            }
        },
        actualizaMontoIngreso(){            
            if (this.ingresos.tipoActividad == 42) {
                //this.ingresos.ingresoNeto = ''
                //this.ingresos.ingresoBruto = '0'
                //this.ingresos.comprobanteIngresos = 4
                document.getElementById('ingresos.ingresoNeto').disabled = true
                document.getElementById('ingresos.ingresoBruto').disabled = false
                document.getElementById('formaComprobarIngresos').disabled = false
                
            }else{
                    //this.ingresos.ingresoNeto = '0'
                    //this.ingresos.ingresoBruto = ''
                    document.getElementById('ingresos.ingresoBruto').disabled = true
                    document.getElementById('ingresos.ingresoNeto').disabled = false
                    
                    if (this.ingresos.tipoActividad == 14) {
                        document.getElementById('formaComprobarIngresos').disabled = false
                        //this.ingresos.comprobanteIngresos = 4
                    }else if(this.ingresos.tipoActividad == 1) {
                        //this.ingresos.comprobanteIngresos = ''
                        document.getElementById('formaComprobarIngresos').disabled = true

                    }

            }
            console.log(this.ingresos.ingresoNeto + " > " +this.ingresos.ingresoBruto)
        },

        dameFechaActual(){
            var now = new Date()                                                    
            var mes = 0
                                       
            switch (now.getMonth()) {
                    case 0:
                        mes = "01"
                        break;
                    case 1:
                        mes = "02"
                        break;
                    case 2:
                        mes = "03"
                        break;
                    case 3:
                        mes = "04"
                        break;
                    case 4:
                        mes = "05"
                        break;
                    case 5:
                        mes = "06"
                        break;
                    case 6:
                        mes = "07"
                        break;
                    case 7:
                        mes = "08"
                        break;
                    case 8:
                        mes = "09"
                        break;
                    case 9:
                        mes = "10"
                    break;
                    case 10:
                        mes = "11"
                        break;
                    case 11:
                        mes = "12"
                        break;                                                        
                }   
            return now.getFullYear() + "-" + mes + "-"+ now.getDate();
        },
        formateaIngresoBruto() {
			if (this.ingresos.ingresoBruto == '') {
				this.ingresos.ingresoBruto = 0
			}
			this.ingresos.ingresoBruto = parseFloat(this.ingresos.ingresoBruto).toFixed(2)
			const exp = /(\d)(?=(\d{3})+(?!\d))/g
			const rep = '$1,'
			this.ingresos.ingresoBruto = this.ingresos.ingresoBruto.toString().replace(exp, rep)
		},
        formateaIngresoNeto() {
			if (this.ingresos.ingresoNeto == '') {
				this.ingresos.ingresoNeto = 0
			}
			this.ingresos.ingresoNeto = parseFloat(this.ingresos.ingresoNeto).toFixed(2)
			const exp = /(\d)(?=(\d{3})+(?!\d))/g
			const rep = '$1,'
			this.ingresos.ingresoNeto = this.ingresos.ingresoNeto.toString().replace(exp, rep)
		},
        aplicarEmailPersonaAfirme() {
            if (Number(this.tipoPersonaAfirme) === 3 && this.emailCoacreditadoCaso) {
                this.email = this.emailCoacreditadoCaso
            } else {
                this.email = this.emailSolicitanteCaso || this.email
            }
        },
        getEstadosSisec() {
            this.$axios
                .post('/', { strApiKey: this.key, strMetodo: 'ListaEstados' }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } })
                .then((response) => {
                    if (response.data.intEstatus == 0) {
                        this.estadosSisec = response.data.objContenido || []
                    }
                })
                .catch(() => {})
        },
        normalizaTexto(value) {
            return String(value || '')
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toUpperCase()
                .trim()
        },
        mapEstadoAfirme(valor) {
            if (valor === null || valor === undefined || valor === '') return ''
            const lista = this.afirmeCatalogos.estados
            const directo = lista.find((item) => item.afirme === valor || item.sisec === valor)
            if (directo) return directo.afirme

            const normalizado = this.normalizaTexto(valor)
            const porNombre = lista.find((item) => {
                return this.normalizaTexto(item.sisec) === normalizado || this.normalizaTexto(item.afirme) === normalizado
            })
            if (porNombre) return porNombre.afirme

            const estadoCatalogo = (this.estadosSisec || []).find((item) => String(item.Id) === String(valor) || String(item.id) === String(valor))
            if (estadoCatalogo) {
                const nombre = estadoCatalogo.Nombre || estadoCatalogo.nombre || ''
                return this.mapEstadoAfirme(nombre)
            }
            return ''
        },
        mapEstadoCivilAfirme(solicitante) {
            const regimen = Number(solicitante.RegimenMatrimonial)
            const civil = Number(solicitante.EstadoCivil)
            if (civil === 1) {
                return regimen === 2 ? 'CASADO(A) MANCOMUNADOS' : 'CASADO(A) BIENES SEPARADOS'
            }
            if (civil === 2) return 'DIVORCIADO(A)'
            if (civil === 3) return 'SOLTERO(A)'
            if (civil === 4) return 'UNION LIBRE'
            if (civil === 5) return 'VIUDO(A)'
            return ''
        },
        mapDestinoAfirme(destino) {
            const idsSustitucion = [19, 22, 25, 33, 34]
            let valor = destino
            if (valor && typeof valor === 'object') {
                valor = valor.Id != null ? valor.Id : (valor.Nombre || valor.NombreDestino || '')
            }
            const texto = this.normalizaTexto(valor)
            if (!texto) return ''
            if (texto === 'SUSTITUCION' || texto.indexOf('SUSTITUC') >= 0 || texto.indexOf('MEJORA') >= 0) {
                return 'SUSTITUCION'
            }
            if (texto === 'ADQUISICION' || texto.indexOf('ADQUISIC') >= 0) {
                return 'ADQUISICION'
            }
            if (idsSustitucion.indexOf(Number(valor)) >= 0) return 'SUSTITUCION'
            if (!isNaN(Number(valor)) && String(valor).trim() !== '') return 'ADQUISICION'
            return ''
        },
        normalizarCurpAfirme() {
            this.afirme.curp = String(this.afirme.curp || '').toUpperCase().replace(/[^A-Z0-9]/g, '').substring(0, 18)
        },
        normalizarRfcAfirme() {
            this.rfc = String(this.rfc || '').toUpperCase().replace(/[^A-Z0-9]/g, '').substring(0, 13)
        },
        mapTipoApoyoAfirme(programa) {
            const id = Number(Array.isArray(programa) ? programa[0] : programa)
            if (id === 4) return 'INFONAVIT'
            if (id === 9) return 'COFINAVIT'
            return 'SIN APOYO'
        },
        llenarAfirmeDesdeCaso(data) {
            const plazos = data.Plazos || []
            this.afirme.montoSolicitado = data.MontoSolicitado || ''
            this.afirme.valorComercial = data.ValorInmueble || ''
            this.afirme.destinoCredito = this.mapDestinoAfirme(data.Destino)
            this.afirme.plazoMaximo = plazos.length ? plazos[plazos.length - 1] : ''
            this.afirme.tipoApoyo = this.mapTipoApoyoAfirme(data.Programas)
        },
        llenarAfirmeDesdeSolicitante(solicitante, ingresos) {
            this.afirme.segundoNombre = solicitante.SegundoNombre || ''
            this.afirme.curp = String(solicitante.Curp || '').toUpperCase().replace(/[^A-Z0-9]/g, '').substring(0, 18)
            this.afirme.telefono = String(solicitante.TelefonoCelular || '').replace(/\D/g, '')
            this.afirme.fechaNacimiento = solicitante.FechaNacimiento || ''
            this.afirme.estadoCivil = this.mapEstadoCivilAfirme(solicitante)
            this.afirme.colonia = solicitante.Colonia || ''
            this.afirme.ciudad = solicitante.Municipio || solicitante.Ciudad || ''
            this.afirme.estado = this.mapEstadoAfirme(solicitante.EstadoNombre || solicitante.Estado)
            if (!this.afirme.estadoInmueble) {
                this.afirme.estadoInmueble = this.afirme.estado
            }
            const aniosDom = solicitante.ScotiaAntiguedadEnDomicilioActualAnios
            const mesesDom = solicitante.ScotiaAntiguedadEnDomicilioActualMeses
            if (aniosDom !== undefined && aniosDom !== null && aniosDom !== '') {
                this.afirme.aniosDireccion = aniosDom
                this.afirme.mesesDireccion = mesesDom || 0
            } else if (solicitante.TiempoViviendoCiudad) {
                this.afirme.aniosDireccion = parseInt(solicitante.TiempoViviendoCiudad, 10) || ''
                this.afirme.mesesDireccion = 0
            }
            if (ingresos && ingresos.length) {
                const ingreso = ingresos[0]
                this.afirme.ingresoMensual = ingreso.IngresosMensuales || ingreso.IngresosNetos || ''
                const fechaInicio = ingreso.FechaInicio ? new Date(ingreso.FechaInicio) : null
                if (fechaInicio && !isNaN(fechaInicio.getTime())) {
                    const ahora = new Date()
                    let meses = (ahora.getFullYear() - fechaInicio.getFullYear()) * 12 + (ahora.getMonth() - fechaInicio.getMonth())
                    if (meses < 0) meses = 0
                    this.afirme.aniosLaboral = Math.floor(meses / 12)
                    this.afirme.mesesLaboral = meses % 12
                }
            }
        },
        avanzarAfirme() {
            this.siguienteAfirmePaso()
        },
        siguienteAfirmePaso() {
            if (this.afirme.tab === 'personales') {
                if (!this.afirmePersonalesCompletos) return
                this.afirme.tab = 'domicilio'
            } else if (this.afirme.tab === 'domicilio') {
                if (!this.afirmeDomicilioCompletos) return
                this.afirme.tab = 'credito'
            }
        },
        regresarAfirmePaso() {
            if (this.afirme.tab === 'credito') this.afirme.tab = 'domicilio'
            else if (this.afirme.tab === 'domicilio') this.afirme.tab = 'personales'
        },
        cerrarFormularioAfirme() {
            this.afirme.tab = 'personales'
            this.$emit('bandera', 'cerrarAfirme')
        },
        consultarAfirme() {
            if (!this.afirmeCamposCompletos) {
                this.$vs.notify({
                    title: 'Información',
                    text: 'Asegúrate de llenar todos los campos obligatorios',
                    color: 'warning',
                    position: 'top-right',
                })
                return
            }
            this.$vs.dialog({
                color: 'primary',
                title: 'Precalificación Bancaria',
                text: '¿Estás seguro que deseas enviar esta precalificación al portal de Afirme? Asegúrate de que tus credenciales para esta financiera estén correctas.',
                acceptText: 'Aceptar',
                accept: () => {
                    // Diferir para que Vuesax cierre el dialog antes de mutar el DOM
                    // (evita TypeError clientWidth en acceptDialog/clickButton)
                    setTimeout(() => {
                        this.precalificacionLineaAfirme()
                    }, 350)
                },
            })
        },
        catalogoErrorAfirme(codigo) {
            const clave = String(codigo || '').toUpperCase()
            const mensajes = {
                '400': 'Los datos enviados no son válidos. Verifique la información capturada.',
                'BAD REQUEST': 'Los datos enviados no son válidos. Verifique la información capturada.',
                '401': 'No autorizado. Verifique las credenciales de conexión con Afirme.',
                'UNAUTHORIZED': 'No autorizado. Verifique las credenciales de conexión con Afirme.',
                '403': 'Acceso denegado por el servicio de Afirme.',
                'FORBIDDEN': 'Acceso denegado por el servicio de Afirme.',
                '404': 'No se encontró la evaluación solicitada en Afirme.',
                'NOT FOUND': 'No se encontró la evaluación solicitada en Afirme.',
                '408': 'Tiempo de espera agotado al consultar Afirme.',
                'TIMEOUT': 'Tiempo de espera agotado al consultar Afirme.',
                '429': 'Se excedió el número de solicitudes permitidas. Intente más tarde.',
                '500': 'Error interno en el servicio de Afirme. Intente más tarde.',
                'INTERNAL SERVER ERROR': 'Error interno en el servicio de Afirme. Intente más tarde.',
                '502': 'El servicio de Afirme no respondió correctamente. Intente más tarde.',
                '503': 'El servicio de Afirme no está disponible temporalmente.',
                'SERVICE UNAVAILABLE': 'El servicio de Afirme no está disponible temporalmente.',
            }
            return mensajes[clave] || ''
        },
        esRespuestaErrorAfirme(contenido) {
            const estatus = String((contenido && (contenido.decreeStatus || contenido.DecreeStatus)) || '').toUpperCase()
            return ['ERROR', 'RECHAZADO', 'REJECTED', 'DECLINED', 'DECLINADO', 'FALLIDO', 'FAILED'].indexOf(estatus) >= 0
        },
        mensajeErrorAfirme(data) {
            const contenido = (data && data.objContenido) || {}
            const codigo = contenido.errorCode || contenido.code || contenido.httpStatus || contenido.status || data.intEstatus
            const porCatalogo = this.catalogoErrorAfirme(codigo) || this.catalogoErrorAfirme(data.strError)
            if (contenido.statusMessage) return contenido.statusMessage
            if (contenido.StatusMessage) return contenido.StatusMessage
            if (porCatalogo) return porCatalogo
            if (data.strError) {
                if (String(data.strError).indexOf('inexistente') >= 0) {
                    return 'El API aún no tiene el método SolicitarEnLineaAfirme. Hay que publicar el index.php actualizado en pcotizador/apipro.'
                }
                return data.strError
            }
            return 'No fue posible obtener la precalificación de Afirme.'
        },
        confirmarPrecalificacion() {
            // Diferir: vs-prompt/Vuesax aún anima el botón al aceptar
            setTimeout(() => {
                if (this.esAfirme) {
                    this.precalificacionLineaAfirme()
                } else {
                    this.precalificacionLinea()
                }
            }, 350)
        },
        payloadAfirme() {
            return {
                TipoPersona: this.tipoPersonaAfirme,
                Nombre: this.nombre,
                SegundoNombre: this.afirme.segundoNombre,
                ApellidoPaterno: this.apellidoPaterno,
                ApellidoMaterno: this.apellidoMaterno,
                Rfc: this.rfc,
                Curp: this.afirme.curp,
                EstadoCivil: this.afirme.estadoCivil,
                TipoPersonaFiscal: this.afirme.tipoPersonaFiscal,
                CodigoPais: String(this.afirme.codigoPais || '52').replace(/\D/g, '') || '52',
                Telefono: this.afirme.telefono,
                Email: this.email,
                FechaNacimiento: this.afirme.fechaNacimiento,
                NumeroCliente: this.afirme.numeroCliente,
                AniosAntiguedadLaboral: this.afirme.aniosLaboral,
                MesesAntiguedadLaboral: this.afirme.mesesLaboral,
                IngresoMensual: this.afirme.ingresoMensual,
                OtrosIngresos: this.afirme.otrosIngresos,
                PorcentajeParticipacion: this.afirme.porcentajeParticipacion,
                Impuestos: this.afirme.impuestos,
                TipoEmpleo: this.afirme.tipoEmpleo,
                TotalDeudas: this.afirme.totalDeudas,
                Calle: this.calle,
                NumeroExterior: this.numeroExterior,
                NumeroInterior: this.numeroInterior,
                Colonia: this.afirme.colonia,
                Estado: this.afirme.estado,
                Ciudad: this.afirme.ciudad,
                CodigoPostal: this.codigoPostal,
                AniosAntiguedadDireccion: this.afirme.aniosDireccion,
                MesesAntiguedadDireccion: this.afirme.mesesDireccion,
                MontoSolicitado: this.afirme.montoSolicitado,
                ValorComercial: this.afirme.valorComercial,
                DestinoCredito: this.afirme.destinoCredito,
                TipoGarantia: this.afirme.tipoGarantia,
                TipoPropiedad: this.afirme.tipoPropiedad,
                MontoPresupuesto: this.afirme.montoPresupuesto,
                PagoMensualHipoteca: this.afirme.pagoMensualHipoteca,
                PlazoMaximo: this.afirme.plazoMaximo,
                EstadoInmueble: this.afirme.estadoInmueble,
                TipoTramite: this.afirme.tipoTramite,
                TipoApoyo: this.afirme.tipoApoyo,
                ApoyoInfonavit: this.afirme.apoyoInfonavit,
                DeduccionesInfonavit: this.afirme.deduccionesInfonavit,
            }
        },
        async precalificacionLineaAfirme() {
            this.$vs.loading({ container: '#container', scale: 0.6 })
            try {
                const objRequest = {
                    strFolioCaso: this.id,
                    strApiKey: this.key,
                    strMetodo: 'SolicitarEnLineaAfirme',
                    objCaso: {
                        Id: this.id,
                        EMail: this.email,
                        Banco: 12,
                        TipoPersona: this.tipoPersonaAfirme,
                        DatosCredito: {
                            Plazo: this.caso.Plazos[0],
                            Programa: this.caso.Programas[0],
                            Esquema: this.caso.Esquemas[0],
                            Destino: this.caso.Destino,
                            MontoSolicitado: this.afirme.montoSolicitado || this.caso.MontoSolicitado,
                            ValorPropiedad: this.afirme.valorComercial || this.caso.ValorInmueble,
                            Variante: Number(this.varianteId) || null,
                        },
                        DatosAfirme: this.payloadAfirme(),
                    },
                }
                const response = await this.$axios.post('/', objRequest, { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } })
                const contenido = response.data.objContenido || {}
                if (response.data.intEstatus === 0) {
                    if (this.esRespuestaErrorAfirme(contenido)) {
                        this.$vs.notify({
                            title: 'No fue posible obtener la precalificación de Afirme',
                            text: this.mensajeErrorAfirme(response.data),
                            color: 'danger',
                            position: 'top-right',
                        })
                    } else {
                        this.$vs.notify({
                            title: 'Precalificación Afirme',
                            text: contenido.statusMessage || contenido.strInformacion || 'Solicitud enviada. El resultado se mostrará en el historial de precalificaciones.',
                            color: 'success',
                            position: 'top-right',
                        })
                    }
                    // Emitir después del loading para no chocar con el cierre del dialog/prompt
                    setTimeout(() => {
                        this.$emit('bandera', 'Personales')
                    }, 200)
                } else {
                    this.$vs.notify({
                        title: 'No fue posible obtener la precalificación de Afirme',
                        text: this.mensajeErrorAfirme(response.data),
                        color: 'danger',
                        position: 'top-right',
                    })
                }
            } catch (error) {
                this.$vs.notify({
                    title: 'Ocurrio un error de sistema',
                    text: error,
                    color: 'danger',
                    position: 'top-right',
                })
            }
            this.$vs.loading.close('#container > .con-vs-loading')
        },

    },

}

</script>



<style lang="css">
    
    .btn-large {
        min-width: 100%;
        height: 100%;
        margin: 0 !important;
    }
    .sizeIputAntiguedadLaboral{
        width: 30%;
    }
    .popup_success{
        display: flex;
        justify-content: center;
        text-align: center;
        font-weight: bold;
    }
    .hgs{
        height: 45%;
    }
    .responsive-input {             
        padding-top: 5px;   
    }    

    
@media (max-width: 1200px) {
    .responsive-input {
        width: 80%; 
        /*font-size: 10px; */
        padding-top: 10px;   
        margin-top: 5%;    
    }
    .responsive-select{
        font-size: 10px;
    }
}
.afirme-tabs .nav-link {
    cursor: pointer;
}
.afirme-preca {
    padding: 8px 8px 24px;
}
.afirme-back {
    display: inline-block;
    color: #e11d2e;
    font-weight: 600;
    text-decoration: none;
    margin-bottom: 8px;
}
.afirme-back:hover {
    color: #c41626;
    text-decoration: none;
}
.afirme-title {
    color: #0b3a82;
    font-size: 28px;
    font-weight: 700;
    margin: 0 0 16px;
}
.afirme-preca .afirme-tabs {
    display: flex;
    gap: 0;
    border-bottom: none;
    margin-bottom: 0;
}
.afirme-preca .afirme-tabs .nav-item {
    flex: 0 0 auto;
}
.afirme-preca .afirme-tabs .nav-link {
    background: #d7e8fb;
    color: #3d5a80;
    border: none;
    border-radius: 8px 8px 0 0;
    padding: 10px 28px;
    font-weight: 600;
    margin-right: 4px;
}
.afirme-preca .afirme-tabs .nav-link.active {
    background: #fff;
    color: #0b3a82;
    text-decoration: none;
    box-shadow: 0 -1px 0 #fff;
}
.afirme-card {
    background: #fff;
    border-radius: 0 8px 8px 8px;
    box-shadow: 0 2px 10px rgba(15, 40, 80, 0.08);
    padding: 24px 28px 20px;
}
.afirme-section {
    color: #0b3a82;
    font-size: 18px;
    font-weight: 700;
    margin: 8px 0 16px;
}
.afirme-field {
    margin-bottom: 16px;
}
.afirme-label {
    display: block;
    color: #4b5563;
    font-size: 13px;
    font-weight: 500;
    margin-bottom: 6px;
}
.afirme-input {
    width: 100%;
    min-height: 40px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    padding: 8px 12px;
    background: #fff;
    color: #1f2937;
}
.afirme-input:focus {
    outline: none;
    border-color: #2f80ed;
    box-shadow: 0 0 0 2px rgba(47, 128, 237, 0.15);
}
.afirme-phone {
    display: flex;
    align-items: stretch;
}
.afirme-phone-prefix {
    display: flex;
    align-items: center;
    padding: 0 10px;
    background: #f3f4f6;
    border: 1px solid #d1d5db;
    border-right: none;
    border-radius: 6px 0 0 6px;
    color: #6b7280;
    font-weight: 600;
}
.afirme-phone .afirme-input {
    border-radius: 0 6px 6px 0;
}
.afirme-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 24px;
}
.afirme-btn-regresar,
.afirme-btn-siguiente {
    min-width: 120px;
    min-height: 42px;
    border-radius: 6px;
    font-weight: 600;
    padding: 8px 20px;
}
.afirme-btn-regresar {
    background: #fff;
    border: 1px solid #c5d0dc;
    color: #334155;
}
.afirme-btn-regresar:disabled {
    background: #eef2f6;
    color: #94a3b8;
    border-color: #e2e8f0;
    cursor: not-allowed;
}
.afirme-btn-siguiente {
    background: #2f80ed;
    border: 1px solid #2f80ed;
    color: #fff;
}
.afirme-btn-siguiente:disabled {
    background: #9dc0f5;
    border-color: #9dc0f5;
    cursor: not-allowed;
}
   
</style>


